(function () {
    'use strict';

    /**
     * SUP-12293: when a user's access ends. The server keeps one instant (User.accessValidUntil: from then on the account
     * can neither sign in nor be used); the screen shows and asks for the last day the access still works, in the
     * browser's time zone, so "31/10" means "until the end of 31 October" — the instant is the following midnight.
     */
    angular.module('eDocumentsApp').factory('UserAccessWindow', UserAccessWindow);

    function UserAccessWindow() {
        var MAX_DAYS = 90;
        var FULL_ACCESS_ROLES = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SUPERADMIN', 'ROLE_PARTNER', 'ROLE_INTEGRATION'];

        return {
            lastDay: lastDay,
            endOf: endOf,
            hasEnded: hasEnded,
            isRestricted: isRestricted,
            maxLastDay: maxLastDay,
            isoDay: isoDay,
        };

        /** No role that opens the application: the account must have an end date (server: UserAccessPolicy). */
        function isRestricted(authorities) {
            return !(authorities || []).some(function (role) {
                return FULL_ACCESS_ROLES.indexOf(role) !== -1;
            });
        }

        /** The latest last day an end date may have: 90 days from today. */
        function maxLastDay() {
            var today = new Date();
            return new Date(today.getFullYear(), today.getMonth(), today.getDate() + MAX_DAYS);
        }

        /** yyyy-MM-dd of a local date, as the date input's min/max want it. */
        function isoDay(day) {
            function pad(n) {
                return (n < 10 ? '0' : '') + n;
            }
            return day.getFullYear() + '-' + pad(day.getMonth() + 1) + '-' + pad(day.getDate());
        }

        /** The last day the access works, as a local date (midnight); null without an end. */
        function lastDay(accessValidUntil) {
            if (!accessValidUntil) {
                return null;
            }
            var end = new Date(accessValidUntil);
            if (isNaN(end.getTime())) {
                return null;
            }
            var last = new Date(end.getTime() - 1);
            return new Date(last.getFullYear(), last.getMonth(), last.getDate());
        }

        /** The instant (ISO string) the access ends when its last day is the given local date; null without one. */
        function endOf(day) {
            if (!day || isNaN(new Date(day).getTime())) {
                return null;
            }
            var d = new Date(day);
            return new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1).toISOString();
        }

        function hasEnded(accessValidUntil) {
            return !!accessValidUntil && new Date(accessValidUntil).getTime() <= Date.now();
        }
    }
})();
